'use strict';

var React = require('react');

var SvgFraudProtectPendingMinor = function SvgFraudProtectPendingMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.822 12.683c-1.349 2.513-3.885 4.485-6.818 5.317-2.935-.832-5.471-2.804-6.82-5.317-1.344-2.502-1.542-5.536-.586-8.808 1.362-.089 4.385-.448 7.406-1.875 3.02 1.427 6.043 1.786 7.404 1.875.958 3.272.758 6.306-.586 8.808zm-3.822-2.683a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-4 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
  }));
};

exports.SvgFraudProtectPendingMinor = SvgFraudProtectPendingMinor;
